import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('redirect');
const GET_REDIRECT = define('GET_REDIRECT', true);
const CREATE_REDIRECT = define('CREATE_REDIRECT', true);
const DELETE_REDIRECT = define('DELETE_REDIRECT', true);
const UPDATE_REDIRECT = define('UPDATE_REDIRECT', true);

const initialState = {
  redirects: [],
  isLoading: true,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REDIRECT.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_REDIRECT.RESOLVED:
      return {
        ...state,
        redirects: action.data,
        isLoading: false,
      };
    case GET_REDIRECT.REJECTED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const actions = {
  getRedirect: () => ({
    type: GET_REDIRECT,
    promise: api.get('/redirects'),
    error: 'Unable to load redirects'
  }),
  deleteRedirect: id => ({
    type: DELETE_REDIRECT,
    promise: api.delete(`/redirects/${id}`)
  }),
  updateRedirect: (id, data) => ({
    type: UPDATE_REDIRECT,
    promise: api.put(`/redirects/${id}`, data),
    success: 'Redirect has been updated',
    error: 'Unable to update redirect'
  }),
  createRedirect: data => ({
    type: CREATE_REDIRECT,
    promise: api.post('/redirects', data),
    success: 'Redirect has been created',
    error: 'Unable to create redirect'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/redirect.js